import { render, staticRenderFns } from "./KullaniciIzinleriForm.vue?vue&type=template&id=b76f6c92&scoped=true"
import script from "./KullaniciIzinleriForm.vue?vue&type=script&lang=ts"
export * from "./KullaniciIzinleriForm.vue?vue&type=script&lang=ts"
import style0 from "./KullaniciIzinleriForm.vue?vue&type=style&index=0&id=b76f6c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76f6c92",
  null
  
)

export default component.exports